// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"xK-z","smallCardRow":"yK-z","largeCardRow":"zK-z","productSearchRow":"AK-z","curatedRow":"BK-z"};